import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'groupByKey'
})
export class GroupByKeyPipe implements PipeTransform {
	transform<T>(array: T[], key: keyof T): { key: string, values: T[] }[] {
		const grouped = new Map<string, T[]>();

		array.forEach((item: T) => {
			const groupKey = String(item[key] ?? 'Other');
			if (!grouped.has(groupKey)) {
				grouped.set(groupKey, []);
			}
			grouped.get(groupKey)!.push(item);
		});

		return Array.from(grouped.entries()).map(([key, values]) => ({ key, values }));
	}
}
